import { render } from "./NxgTrackOrder.vue?vue&type=template&id=fbbabb50"
import script from "./NxgTrackOrder.vue?vue&type=script&lang=js"
export * from "./NxgTrackOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__